// src/components/layout/PublicHeader.tsx
import React from 'react';

interface PublicHeaderProps {
    onLogin: () => void;
    onRegister: () => void;
}

/**
 * Landing-page header.
 *
 * Deliberately does NOT import styles/layout/Header.css — that file is shared with
 * the in-game header, and the landing page has its own visual language. The auth
 * modals live on HomePage so a single instance serves the whole page.
 */
export const PublicHeader: React.FC<PublicHeaderProps> = ({ onLogin, onRegister }) => {
    return (
        <header className="lp-header">
            <div className="lp-header__inner">
                <button
                    type="button"
                    className="lp-header__brand"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    aria-label="Võmm.ee avalehele"
                >
                    <img
                        src="/images/vommlogo.png"
                        alt=""
                        className="lp-header__badge"
                        width={30}
                        height={30}
                    />
                    <span className="lp-header__wordmark">Võmm<span>.</span>ee</span>
                </button>

                <div className="lp-header__actions">
                    <button type="button" className="lp-header__link" onClick={onLogin}>
                        Logi sisse
                    </button>
                    <button type="button" className="lp-header__cta" onClick={onRegister}>
                        Alusta mängu
                    </button>
                </div>
            </div>
        </header>
    );
};
